// extracted by mini-css-extract-plugin
var _1 = "styles_container__0AzcZ";
export { _1 as "container" }
